if (typeof loadeMoreSlider_G === 'undefined') {
	globalThis.loadeMoreSlider_G = null;
}

(function () {
	const HOVER_DELAY = 1200;
	const SLIDE_SPEED = 300;
	const MAX_SLIDES = 4;

	let initFrame = null;
	let observer = null;

	const getWrapper = (slider) => {
		return slider.querySelector('.swiper-wrapper');
	};

	const removeManagedClones = (slider) => {
		const clones = slider.querySelectorAll('.product-hover-slider-clone');

		clones.forEach((clone) => {
			clone.remove();
		});
	};

	const removeSwiperDuplicates = (slider) => {
		const duplicates = slider.querySelectorAll('.swiper-slide-duplicate');

		duplicates.forEach((duplicate) => {
			duplicate.remove();
		});
	};

	const getOriginalSlides = (slider) => {
		return Array.from(
			slider.querySelectorAll('.swiper-wrapper > .swiper-slide:not(.product-hover-slider-clone):not(.swiper-slide-duplicate)')
		);
	};

	const getActiveSlides = (slider) => {
		return getOriginalSlides(slider).slice(0, MAX_SLIDES);
	};

	const getRealSlideCount = (slider) => {
		const activeSlides = getActiveSlides(slider);
		const countFromDom = activeSlides.length || Number(slider.dataset.hoverSlideCount || MAX_SLIDES);

		return Math.max(1, Math.min(countFromDom, MAX_SLIDES));
	};

	const stopTimer = (slider) => {
		if (slider.hoverSliderTimer) {
			clearInterval(slider.hoverSliderTimer);
			slider.hoverSliderTimer = null;
		}
	};

	const ensureProgress = (slider) => {
		let progress = slider.querySelector('.product-hover-progress');
		const slideCount = getRealSlideCount(slider);

		if (!progress) {
			progress = document.createElement('div');
			progress.className = 'product-hover-progress';
			progress.setAttribute('aria-hidden', 'true');
			slider.appendChild(progress);
		}

		progress.classList.remove('product-pagination');
		progress.classList.add('product-hover-progress');

		if (progress.querySelectorAll('.product-hover-progress__segment').length !== slideCount) {
			progress.innerHTML = '';

			for (let i = 0; i < slideCount; i += 1) {
				const segment = document.createElement('span');
				segment.className = 'product-hover-progress__segment';

				if (i === 0) {
					segment.classList.add('is-active');
				}

				progress.appendChild(segment);
			}
		}

		return progress;
	};

	const setActiveProgress = (slider, index) => {
		const slideCount = getRealSlideCount(slider);
		const realIndex = ((index % slideCount) + slideCount) % slideCount;
		const segments = slider.querySelectorAll('.product-hover-progress__segment');

		segments.forEach((segment, segmentIndex) => {
			segment.classList.toggle('is-active', segmentIndex === realIndex);
		});
	};

	const setWrapperTransform = (slider, index, speed) => {
		const wrapper = getWrapper(slider);

		if (!wrapper) return;

		wrapper.style.transitionProperty = 'transform';
		wrapper.style.transitionTimingFunction = 'ease';
		wrapper.style.transitionDuration = `${speed}ms`;
		wrapper.style.transform = `translate3d(-${index * 100}%, 0px, 0px)`;
	};

	const resetSlideClasses = (slider, activeIndex) => {
		const wrapper = getWrapper(slider);

		if (!wrapper) return;

		const slides = Array.from(wrapper.querySelectorAll('.swiper-slide'));
		const slideCount = getRealSlideCount(slider);
		const realActiveIndex = ((activeIndex % slideCount) + slideCount) % slideCount;

		slides.forEach((slide, index) => {
			const realIndex = index % slideCount;

			slide.classList.toggle('swiper-slide-active', realIndex === realActiveIndex);
			slide.classList.toggle('swiper-slide-next', realIndex === (realActiveIndex + 1) % slideCount);
			slide.classList.toggle(
				'swiper-slide-prev',
				realIndex === (realActiveIndex - 1 + slideCount) % slideCount
			);
		});
	};

	const destroyExistingSwiper = (slider) => {
		if (!slider.swiper || slider.swiper.destroyed) return;

		try {
			slider.swiper.destroy(true, true);
		} catch (error) {
			console.warn('Failed to destroy existing product card swiper:', error);
		}
	};

	const prepareSlider = (slider) => {
		const wrapper = getWrapper(slider);

		if (!wrapper) return false;

		destroyExistingSwiper(slider);
		removeManagedClones(slider);
		removeSwiperDuplicates(slider);

		const originalSlides = getOriginalSlides(slider);
		const activeSlides = originalSlides.slice(0, MAX_SLIDES);

		if (!activeSlides.length) return false;

		originalSlides.forEach((slide, index) => {
	if (index < MAX_SLIDES) {
		slide.style.display = '';
		slide.style.width = '100%';
		slide.style.maxWidth = '100%';
		slide.style.minWidth = '100%';
		slide.style.flex = '0 0 100%';
		slide.style.margin = '0';
		slide.style.padding = '0';
		slide.style.boxSizing = 'border-box';
		slide.style.overflow = 'hidden';
	} else {
		slide.style.display = 'none';
	}

	slide.classList.remove('swiper-slide-duplicate');
});

		if (activeSlides.length > 1) {
			const firstClone = activeSlides[0].cloneNode(true);

			firstClone.classList.add('product-hover-slider-clone');
			firstClone.classList.add('swiper-slide-duplicate');
			firstClone.setAttribute('aria-hidden', 'true');
			firstClone.style.display = '';
			firstClone.style.width = '100%';
			firstClone.style.flex = '0 0 100%';

			wrapper.appendChild(firstClone);
		}

		wrapper.style.display = 'flex';
		wrapper.style.flexWrap = 'nowrap';
		wrapper.style.willChange = 'transform';
		wrapper.style.transitionProperty = 'transform';
		wrapper.style.transform = 'translate3d(0px, 0px, 0px)';
		wrapper.style.transitionDuration = '0ms';

		slider.style.position = 'relative';
slider.style.display = 'block';
slider.style.width = '100%';
slider.style.maxWidth = '100%';
slider.style.minWidth = '0';
slider.style.overflow = 'hidden';
slider.style.boxSizing = 'border-box';
slider.style.contain = 'layout paint';

const mediaParent = slider.closest('.media--hover-effect');

if (mediaParent) {
	mediaParent.style.position = 'relative';
	mediaParent.style.width = '100%';
	mediaParent.style.maxWidth = '100%';
	mediaParent.style.minWidth = '0';
	mediaParent.style.overflow = 'hidden';
	mediaParent.style.boxSizing = 'border-box';
}

wrapper.style.width = '100%';
wrapper.style.maxWidth = '100%';
wrapper.style.minWidth = '0';
wrapper.style.margin = '0';
wrapper.style.padding = '0';
wrapper.style.gap = '0';
wrapper.style.boxSizing = 'border-box';

slider.dataset.hoverSliderPrepared = 'true';

		ensureProgress(slider);
		setActiveProgress(slider, 0);
		resetSlideClasses(slider, 0);

		return true;
	};

	const jumpToRealFirstAfterClone = (slider) => {
		const slideCount = getRealSlideCount(slider);

		if (slider.hoverSliderIndex !== slideCount) return;

		slider.hoverSliderIndex = 0;

		setWrapperTransform(slider, 0, 0);
		resetSlideClasses(slider, 0);
		setActiveProgress(slider, 0);
	};

	const forceFirstSlide = (slider) => {
		stopTimer(slider);

		slider.hoverSliderIndex = 0;
		slider.classList.remove('is-hovering-slider');

		setWrapperTransform(slider, 0, 0);
		resetSlideClasses(slider, 0);
		setActiveProgress(slider, 0);
	};

	const moveToIndex = (slider, index, speed) => {
		const slideCount = getRealSlideCount(slider);

		slider.hoverSliderIndex = index;

		setWrapperTransform(slider, index, speed);
		resetSlideClasses(slider, index);
		setActiveProgress(slider, index % slideCount);
	};

	const startHoverSlider = (slider) => {
		if (!prepareSlider(slider)) return;

		const slideCount = getRealSlideCount(slider);

		if (slideCount <= 1) {
			forceFirstSlide(slider);
			return;
		}

		stopTimer(slider);

		slider.classList.add('is-hovering-slider');

		moveToIndex(slider, 1, 0);

		slider.hoverSliderTimer = setInterval(() => {
			const currentIndex =
				typeof slider.hoverSliderIndex === 'number' ? slider.hoverSliderIndex : 1;

			const nextIndex = currentIndex + 1;

			moveToIndex(slider, nextIndex, SLIDE_SPEED);
		}, HOVER_DELAY);
	};

	const bindHoverEvents = (slider) => {
		if (slider.dataset.hoverEventsBound === 'true') return;

		const wrapper = getWrapper(slider);
		const hoverTarget = slider.closest('.media--hover-effect') || slider;
		const cardWrapper = slider.closest('.card-wrapper');

		const enter = () => {
	if (window.matchMedia('(max-width: 749px)').matches) return;

	startHoverSlider(slider);
};

const leave = () => {
	if (window.matchMedia('(max-width: 749px)').matches) return;

	forceFirstSlide(slider);
};

		if (wrapper) {
			wrapper.addEventListener('transitionend', (event) => {
				if (event.propertyName !== 'transform') return;

				jumpToRealFirstAfterClone(slider);
			});
		}

		hoverTarget.addEventListener('pointerenter', enter);
		hoverTarget.addEventListener('mouseenter', enter);

		hoverTarget.addEventListener('pointerleave', leave);
		hoverTarget.addEventListener('mouseleave', leave);

		slider.addEventListener('pointerleave', leave);
		slider.addEventListener('mouseleave', leave);

		if (cardWrapper) {
			cardWrapper.addEventListener('mouseleave', leave);
			cardWrapper.addEventListener('focusout', leave);
		}

		hoverTarget.addEventListener('focusin', enter);
		hoverTarget.addEventListener('focusout', leave);

		slider.dataset.hoverEventsBound = 'true';
	};

	const initOneSlider = (slider) => {
		if (!slider) return;

		prepareSlider(slider);
		bindHoverEvents(slider);
		forceFirstSlide(slider);
	};

	const initSlider = () => {
		const sliders = document.querySelectorAll('.product-card-js');

		sliders.forEach((slider) => {
			initOneSlider(slider);
		});
	};

	const scheduleInit = () => {
		if (initFrame) {
			cancelAnimationFrame(initFrame);
		}

		initFrame = requestAnimationFrame(() => {
			initFrame = null;
			initSlider();
		});
	};

	const observeDynamicCards = () => {
		if (observer || !document.body) return;

		observer = new MutationObserver((mutations) => {
			let shouldInit = false;

			mutations.forEach((mutation) => {
				mutation.addedNodes.forEach((node) => {
					if (!(node instanceof HTMLElement)) return;

					if (
						node.classList.contains('product-card-js') ||
						node.querySelector('.product-card-js')
					) {
						shouldInit = true;
					}
				});
			});

			if (shouldInit) {
				scheduleInit();
			}
		});

		observer.observe(document.body, {
			childList: true,
			subtree: true,
		});
	};

	globalThis.loadeMoreSlider_G = initSlider;

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', function () {
			scheduleInit();
			observeDynamicCards();
		});
	} else {
		scheduleInit();
		observeDynamicCards();
	}

	document.addEventListener('shopify:section:load', scheduleInit);
	document.addEventListener('shopify:section:reorder', scheduleInit);

	window.addEventListener('load', scheduleInit);
	window.addEventListener('resize', scheduleInit);
})();
(function () {
	const MOBILE_QUERY = '(max-width: 749px)';
	const SWIPE_THRESHOLD = 35;
	const SLIDE_SPEED = 300;

	let didSwipe = false;

	const isMobile = () => {
		return window.matchMedia(MOBILE_QUERY).matches;
	};

	const getCardSliders = () => {
		return document.querySelectorAll('.product-card-js');
	};

	const getWrapper = (slider) => {
		return slider.querySelector('.swiper-wrapper');
	};

	const getSlides = (slider) => {
		const wrapper = getWrapper(slider);

		if (!wrapper) return [];

		return Array.from(
			wrapper.querySelectorAll(
				'.swiper-slide:not(.product-hover-slider-clone):not(.swiper-slide-duplicate)'
			)
		);
	};

	const getAllSlides = (slider) => {
		const wrapper = getWrapper(slider);

		if (!wrapper) return [];

		return Array.from(wrapper.querySelectorAll('.swiper-slide'));
	};

	const getProgressSegments = (slider) => {
		return Array.from(
			slider.querySelectorAll('.product-hover-progress__segment')
		);
	};

	const forceProgressStyle = (slider, show = false) => {
		const progress = slider.querySelector('.product-hover-progress');
		const segments = getProgressSegments(slider);

		if (!progress) return;

		progress.style.setProperty('position', 'absolute', 'important');
		progress.style.setProperty('left', '0', 'important');
		progress.style.setProperty('right', '0', 'important');
		progress.style.setProperty('bottom', '0', 'important');
		progress.style.setProperty('z-index', '999', 'important');
		progress.style.setProperty('display', 'flex', 'important');
		progress.style.setProperty('width', '100%', 'important');
		progress.style.setProperty('height', '4px', 'important');
		progress.style.setProperty('min-height', '4px', 'important');
		progress.style.setProperty('background', '#b5b7b9', 'important');
		progress.style.setProperty('pointer-events', 'none', 'important');
		progress.style.setProperty('transform', 'translate3d(0, 0, 1px)', 'important');
		progress.style.setProperty('transition', 'opacity 180ms ease', 'important');
		progress.style.setProperty('opacity', show ? '1' : '0', 'important');
		progress.style.setProperty('visibility', show ? 'visible' : 'hidden', 'important');

		segments.forEach((segment) => {
			segment.style.setProperty('display', 'block', 'important');
			segment.style.setProperty('flex', '1 1 0', 'important');
			segment.style.setProperty('height', '4px', 'important');
			segment.style.setProperty('min-height', '4px', 'important');
			segment.style.setProperty('opacity', '1', 'important');
			segment.style.setProperty('visibility', 'visible', 'important');
		});
	};

	const getCurrentIndex = (slider) => {
		const slides = getSlides(slider);
		const count = slides.length;

		if (!count) return 0;

		const savedIndex =
			typeof slider.mobileSwipeIndex === 'number'
				? slider.mobileSwipeIndex
				: Number(slider.dataset.mobileSwipeIndex || 0);

		return ((savedIndex % count) + count) % count;
	};

	const setProgress = (slider, index, show = true) => {
		const slides = getSlides(slider);
		const count = slides.length;

		if (!count) return;

		const safeIndex = ((index % count) + count) % count;
		const segments = getProgressSegments(slider);

		forceProgressStyle(slider, show);

		segments.forEach((segment, segmentIndex) => {
			const isActive = segmentIndex === safeIndex;

			segment.classList.toggle('is-active', isActive);
			segment.style.setProperty(
				'background',
				isActive ? '#ffffff' : '#b5b7b9',
				'important'
			);
		});
	};

	const setSlideClasses = (slider, index) => {
		const slides = getAllSlides(slider);
		const realSlides = getSlides(slider);
		const count = realSlides.length;

		if (!count) return;

		const safeIndex = ((index % count) + count) % count;

		slides.forEach((slide, slideIndex) => {
			const realIndex = slide.classList.contains('product-hover-slider-clone')
				? 0
				: slideIndex;

			slide.classList.toggle('swiper-slide-active', realIndex === safeIndex);
			slide.classList.toggle('swiper-slide-next', realIndex === (safeIndex + 1) % count);
			slide.classList.toggle(
				'swiper-slide-prev',
				realIndex === (safeIndex - 1 + count) % count
			);
		});
	};

	const setTransform = (slider, rawIndex, speed) => {
		const wrapper = getWrapper(slider);

		if (!wrapper) return;

		wrapper.style.transitionProperty = 'transform';
		wrapper.style.transitionTimingFunction = 'ease';
		wrapper.style.transitionDuration = `${speed}ms`;
		wrapper.style.transform = `translate3d(-${rawIndex * 100}%, 0px, 0px)`;
	};

	const snapToRealFirst = (slider) => {
		const wrapper = getWrapper(slider);

		if (!wrapper) return;

		slider.mobileSwipeIndex = 0;
		slider.dataset.mobileSwipeIndex = '0';

		wrapper.style.transitionDuration = '0ms';
		wrapper.style.transform = 'translate3d(0%, 0px, 0px)';

		setSlideClasses(slider, 0);
		setProgress(slider, 0, true);
	};

	const goToRawIndex = (slider, rawIndex, progressIndex) => {
		const slides = getSlides(slider);
		const count = slides.length;

		if (!count) return;

		const safeProgressIndex = ((progressIndex % count) + count) % count;

		slider.mobileSwipeIndex = safeProgressIndex;
		slider.dataset.mobileSwipeIndex = String(safeProgressIndex);

		setTransform(slider, rawIndex, SLIDE_SPEED);
		setSlideClasses(slider, safeProgressIndex);
		setProgress(slider, safeProgressIndex, true);
	};

	const goNext = (slider) => {
		const slides = getSlides(slider);
		const count = slides.length;
		const currentIndex = getCurrentIndex(slider);

		if (count <= 1) return;

		if (currentIndex === count - 1) {
			goToRawIndex(slider, count, 0);
			slider.dataset.mobileSwipeNeedsSnap = 'true';
			return;
		}

		goToRawIndex(slider, currentIndex + 1, currentIndex + 1);
	};

	const goPrev = (slider) => {
		const slides = getSlides(slider);
		const count = slides.length;
		const currentIndex = getCurrentIndex(slider);

		if (count <= 1) return;

		if (currentIndex === 0) {
			goToRawIndex(slider, count - 1, count - 1);
			return;
		}

		goToRawIndex(slider, currentIndex - 1, currentIndex - 1);
	};

	const bindMobileSwipe = (slider) => {
		if (!slider || slider.dataset.mobileCardSwipeV4Bound === 'true') return;

		const wrapper = getWrapper(slider);

		let startX = 0;
		let startY = 0;
		let currentX = 0;
		let currentY = 0;
		let isDown = false;
		let isMoving = false;
		let hideProgressTimer = null;

		const showProgress = () => {
			if (hideProgressTimer) {
				clearTimeout(hideProgressTimer);
				hideProgressTimer = null;
			}

			forceProgressStyle(slider, true);
		};

		const hideProgressSoon = () => {
			if (hideProgressTimer) {
				clearTimeout(hideProgressTimer);
			}

			hideProgressTimer = setTimeout(() => {
				forceProgressStyle(slider, false);
			}, 700);
		};

		const onStart = (event) => {
			if (!isMobile()) return;

			const point = event.touches ? event.touches[0] : event;

			isDown = true;
			isMoving = false;
			didSwipe = false;

			startX = point.clientX;
			startY = point.clientY;
			currentX = startX;
			currentY = startY;
		};

		const onMove = (event) => {
			if (!isDown || !isMobile()) return;

			const point = event.touches ? event.touches[0] : event;

			currentX = point.clientX;
			currentY = point.clientY;

			const diffX = currentX - startX;
			const diffY = currentY - startY;

			if (Math.abs(diffX) > 8 && Math.abs(diffX) > Math.abs(diffY)) {
				isMoving = true;
				showProgress();

				if (event.cancelable) {
					event.preventDefault();
				}
			}
		};

		const onEnd = (event) => {
			if (!isDown || !isMobile()) return;

			isDown = false;

			const diffX = currentX - startX;
			const diffY = currentY - startY;

			if (!isMoving) {
				hideProgressSoon();
				return;
			}

			if (Math.abs(diffX) < SWIPE_THRESHOLD) {
				hideProgressSoon();
				return;
			}

			if (Math.abs(diffY) > Math.abs(diffX)) {
				hideProgressSoon();
				return;
			}

			didSwipe = true;

			if (event.cancelable) {
				event.preventDefault();
			}

			if (diffX < 0) {
				goNext(slider);
			} else {
				goPrev(slider);
			}

			hideProgressSoon();

			window.setTimeout(() => {
				didSwipe = false;
			}, 350);
		};

		const preventSwipeClick = (event) => {
			if (!didSwipe) return;

			event.preventDefault();
			event.stopPropagation();
		};

		if (wrapper) {
			wrapper.addEventListener('transitionend', (event) => {
				if (event.propertyName !== 'transform') return;
				if (slider.dataset.mobileSwipeNeedsSnap !== 'true') return;

				slider.dataset.mobileSwipeNeedsSnap = 'false';
				snapToRealFirst(slider);
			});
		}

		slider.addEventListener('touchstart', onStart, { passive: true, capture: true });
		slider.addEventListener('touchmove', onMove, { passive: false, capture: true });
		slider.addEventListener('touchend', onEnd, { passive: false, capture: true });
		slider.addEventListener('touchcancel', () => {
			isDown = false;
			isMoving = false;
			hideProgressSoon();
		}, { capture: true });

		slider.addEventListener('pointerdown', onStart, true);
		slider.addEventListener('pointermove', onMove, true);
		slider.addEventListener('pointerup', onEnd, true);
		slider.addEventListener('pointercancel', () => {
			isDown = false;
			isMoving = false;
			hideProgressSoon();
		}, true);

		slider.addEventListener('click', preventSwipeClick, true);

		slider.dataset.mobileCardSwipeV4Bound = 'true';
	};

	const initMobileCardSwipe = () => {
	getCardSliders().forEach((slider) => {
		const wrapper = getWrapper(slider);
		const slides = getSlides(slider);
		const allSlides = getAllSlides(slider);
		const progress = slider.querySelector('.product-hover-progress');

		if (!wrapper || slides.length <= 1) return;

		if (!isMobile()) {
			if (progress) {
				progress.style.removeProperty('opacity');
				progress.style.removeProperty('visibility');
				progress.style.removeProperty('display');
				progress.style.removeProperty('height');
				progress.style.removeProperty('min-height');
				progress.style.removeProperty('z-index');
				progress.style.removeProperty('position');
				progress.style.removeProperty('left');
				progress.style.removeProperty('right');
				progress.style.removeProperty('bottom');
				progress.style.removeProperty('width');
				progress.style.removeProperty('background');
				progress.style.removeProperty('pointer-events');
				progress.style.removeProperty('transform');
				progress.style.removeProperty('transition');
			}

			return;
		}

		wrapper.style.display = 'flex';
		wrapper.style.flexWrap = 'nowrap';

		allSlides.forEach((slide) => {
			slide.style.width = '100%';
			slide.style.flex = '0 0 100%';
		});

		bindMobileSwipe(slider);

		const currentIndex = getCurrentIndex(slider);

		setTransform(slider, currentIndex, 0);
		setSlideClasses(slider, currentIndex);
		setProgress(slider, currentIndex, false);
	});
};

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initMobileCardSwipe);
	} else {
		initMobileCardSwipe();
	}

	window.addEventListener('load', initMobileCardSwipe);
	window.addEventListener('resize', initMobileCardSwipe);
	document.addEventListener('shopify:section:load', initMobileCardSwipe);
	document.addEventListener('shopify:section:reorder', initMobileCardSwipe);
})();